/* START_MODULE_CONTRACT
 * PURPOSE: Frontend utility: projectColors.
 * SCOPE: Pure helper functions.
 * DEPENDS: нет
 * LINKS: M-FE-API
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * projectColors - Frontend utility: projectColors.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contract и парный END_METHOD.
 * END_CHANGE_SUMMARY
 */

export const COLORS = [
  '#1976d2', '#388e3c', '#f57c00', '#7b1fa2',
  '#c62828', '#00838f', '#4e342e', '#546e7a',
  '#ad1457', '#283593', '#2e7d32', '#ef6c00',
];

/* START_METHOD_getColorByName */
/* START_CONTRACT: getColorByName
 * PURPOSE: Детерминированно выбрать цвет из палитры по имени (стабильный хеш).
 * INPUTS: { name: string }
 * OUTPUTS: { string - hex-цвет из COLORS }
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-PROJECTS
 * END_CONTRACT: getColorByName
 */
export function getColorByName(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return COLORS[Math.abs(hash) % COLORS.length];
}
/* END_METHOD_getColorByName */
